import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import FrequentPostingModal from "./component/FrequentPostingModal";

import {
  rightAction,
} from "../../../redux/actions";


const columns = [
  {
    title: "Entry ID",
    dataIndex: "entryId",
  },
  {
    title: "Office",
    dataIndex: "office",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
  },
  {
    title: "Account",
    dataIndex: "account",
  },
  {
    title: "Debit",
    dataIndex: "debit",
  },
  {
    title: "Credit",
    dataIndex: "credit",
  },
];


const ViewGLA0600 = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    rightBtn,
    rightAction,
  } = props;

  const { monthList } = appStatic

  const { session } = userData
  const { Title } = Typography;
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [frequentPostingList, setFrequentPostingList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [modalDetail, setModalDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [FrequentPostingDetail, setFrequentPostingDetail] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    getFrequentPostingListAction(state);
  }, []);


  const getFrequentPostingListAction = (params) => {
    // console.log(params)
    let body = {
      session,
    };

    const url = `${definedApi.GetFrequentPostingList}=${params.transactionId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];
        setFrequentPostingDetail(objList[0])
        console.log(objList)

        objList?.pageItems?.forEach((element) => {
          tempArray.push({
            key: element?.id,
            entryId: element?.id
              ? element?.id
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            office: element?.officeName
              ? element?.officeName
              : "-",
            account: element?.glAccountName
              ? element?.glAccountName
              : "-",
            currency: element?.currency
              ? element?.currency.displayLabel || element?.currency.code
              : "-",
            type: element?.glAccountType
              ? element?.glAccountType.value
              : "-",
            debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
            credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
            transactionDate: element?.transactionDate
              ? (`${element?.transactionDate[2]} ${monthList[element?.transactionDate[1] - 1]} ${element?.transactionDate[0]}`)
              : "No transaction Date",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            createdOn: element?.createdDate
              ? (`${element?.createdDate[2]} ${monthList[element?.createdDate[1] - 1]} ${element?.createdDate[0]}`)
              : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setFrequentPostingList(tempArray.filter((item) => item.disabled === false));
        setFrequentPostingList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };


  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };


  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(frequentPostingList);
    setModalDetail(selectedRow)
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      showModal()
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (

    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
    >
      <TopContent pageTitle={appLabel.viewFrequentPosting} pageItems={appStatic.viewFrequentPostingItems} />

      <Card
        title={`${appLabel.FrequentPosting} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >

        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Title level={4} style={{ marginRight: 8 }} >{`Transaction ID - ${frequentPostingList.map((element) => element.transactionId)[0]}`}</Title>
            </div>
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction
            }}
            columns={columns}
            dataSource={frequentPostingList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>

        <FrequentPostingModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          modalDetail={modalDetail}
          FrequentPostingDetail={FrequentPostingDetail}
        />
      </Card>

    </MainLayout>
  );
};


const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0600);
